module.exports = new __parcel__URL__("express.f635ccd6.svg").toString();